<template>
  <b-colorpicker :position="'is-'+position" :representation="'square'"
                 :value="value" :inline="inline"
                 v-model="realValue"
                 :color-formatter="emptyFormater?blanckFormater:colorFormateur"
                 class="customColorPicker" :class="size+' '+customClass"
                @input="onInputChangeValue"
                @active-change="onActiveChange">
    <template #footer="{ color }">
      <w-input :value="color+''" @input="onInputChangeValue"/>
    </template>
    <template #header v-if="title">
      <div class="titleColorPicker">{{title}}</div>
    </template>
  </b-colorpicker>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WInput from "@/components/wrapper/w-input.vue";
import Color from 'buefy/src/utils/color'

@Component({
  components: {WInput}
})
export default class WColorPicker extends Vue {

  @Prop({default: 'blue'})
  private value!: string;
  @Prop({default: 'top-right'})
  private position!: string;
  @Prop({default: 'small'})
  private size!: string;
  @Prop({default: false})
  private inline!: boolean;
  @Prop({default: ''})
  private title!:string;

  @Prop({default:false})
  private emptyFormater!:boolean;
  @Prop({default:''})
  private customClass!:string;

  private realValue: string='#777777';

  private mounted() {
    this.realValue=this.value;
  }

  private colorFormateur(color ){
    return color;
  }

  private blanckFormater(color){
    return " "
  }

  public onInputChangeValue(color: string) {
    if (this.isValidHexColor(color + "")) {
      this.realValue = color+"";
      this.$emit('input', this.realValue);
    }
  }

  public onActiveChange(active: boolean) {
    this.$emit('active-change', active);
  }


  private isValidHexColor(color) {
    // Regular expression for RGB or RGBA hex format
    const regex = /^(#(?:[0-9a-fA-F]{3}){1,2}|rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*(\d(\.\d+)?|\.\d+))?\s*\))$/;

    // Test the color string against the regular expression
    return regex.test(color);
  }


  @Watch('value')
  public onChangePropValue() {
    this.realValue = this.value;
  }

}
</script>

<style  lang="scss">
.customColorPicker{
  .titleColorPicker{
    font-size: 20px;
    font-weight: 900;
    color: var(--black);
    margin-bottom: 8px;
  }
  &.small {
    button {
      font-size: 12px;
    }
  }
  &.large{
    button{
      font-size: 48px;
    }
  }
}
</style>
